import { render, staticRenderFns } from "./RegisterModel.vue?vue&type=template&id=6fe98b14&scoped=true&"
import script from "./RegisterModel.vue?vue&type=script&lang=js&"
export * from "./RegisterModel.vue?vue&type=script&lang=js&"
import style0 from "./RegisterModel.vue?vue&type=style&index=0&id=6fe98b14&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe98b14",
  null
  
)

export default component.exports